import React from 'react';

import { Provider } from 'react-redux';
import configureStore from 'store/configureStore';
import { PersistGate } from 'redux-persist/integration/react';
import { BrowserRouter } from 'react-router-dom';

import RootRouter from './Routing/RootRouter';

const {store, persistor} = configureStore({});

class App extends React.Component {
  render() {
    return (
      <React.Fragment>
        <Provider store={store}>
          <PersistGate persistor={persistor}>
            <BrowserRouter>
              <RootRouter />
            </BrowserRouter>
          </PersistGate>
        </Provider>
      </React.Fragment>
    );
  }
}

export default App;

export { store };



// WEBPACK FOOTER //
// ./src/app/App.jsx